import React from 'react';
import { IconFacebook2, IconInstagram } from '@/assets/icons';

export const SimplePaymentFooter: React.FC = () => (
  <div className="w-full md:h-[130px] shadow-xsr text-[12px] md:text-base">
    <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 h-full">
      <div className="col-span-1 md:col-span-2 text-left">
        <p className="text-paragraph-footer font-normal font-dmsans">
          © 2026 Banca do Ingresso - Todos os direitos reservados.
        </p>
        <p className="text-paragraph-footer font-normal font-dmsans">
          Banca do Ingresso e Eventos Ltda - CNPJ 10.901.355/0001-05. Rua Perimetral Leste, 577 -
          Centro, Santa Fe do Sul - SP, CEP 15.775-000
        </p>
      </div>
      <div className="col-span-1 flex flex-col items-start md:items-center">
        <p className="text-heading-footer font-normal font-dmsans">Nos siga nas redes sociais</p>
        <div className="flex flex-row md:flex-col items-center justify-between w-full md:w-auto md:h-full">
          <div className="flex justify-center space-x-5 md:space-x-10 mt-5 flex-1">
            <a
              href="#"
              className="bg-social rounded-full flex justify-center items-center w-[25px] md:w-[36px] h-[25px] md:h-[36px]"
              onClick={() => window.open('https://www.instagram.com/bancadoingresso/')}
            >
              <IconInstagram className="h-[13.89px] md:h-[20px] text-primary-500" />
            </a>
            <a
              href="#"
              className="bg-social rounded-full flex justify-center items-center w-[25px] md:w-[36px] h-[25px] md:h-[36px]"
              onClick={() => window.open('https://www.facebook.com/bancadoingresso.com.br')}
            >
              <IconFacebook2 className="h-[16.67px] md:h-[24px] text-primary-500" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
);
